var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-user-edit"}},[_c('bread-crumbs',{attrs:{"title":_vm.$t('CreateResource'),"subTitle":_vm.$t('general.SubTitleResource'),"sizeTitle":30,"lineHeightTitle":37,"sizeSubTitle":15,"lineHeightSubTitle":18}}),_c('div',{staticClass:"tabs-container",attrs:{"slot":"no-body"},slot:"no-body"},[(
				_vm.resourceCreatePermission &&
				_vm.objectRPermission &&
				_vm.typeConfigRPermission &&
				_vm.statusRPermission &&
				_vm.roleRPermission
			)?_c('resource-create-tab-account',{attrs:{"roles":_vm.roles,"resource_data":_vm.resourceData,"manual_data_id":_vm.manualDataId,"upload_file_id":_vm.uploadFileId}}):_c('not-permission',{attrs:{"message":_vm.message}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }